export default __webpack_public_path__ + "static/media/list-previous.0e2bef0f.svg";